/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskSignalsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRiskSignalsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRiskSignalsSecurity = {
  option1?: GetRiskSignalsSecurityOption1 | undefined;
  option2?: GetRiskSignalsSecurityOption2 | undefined;
};

export type GetRiskSignalsRequest = {
  /**
   * Inclusive start of the signals window. Defaults to the start of the 7-day calendar window ending at to.
   */
  from?: Date | undefined;
  /**
   * Exclusive end of the signals window. Defaults to now.
   */
  to?: Date | undefined;
  /**
   * Optional concrete MCP server ID. When set, every signal, KPI and exposure figure is computed from findings on that server only.
   */
  mcpServerId?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRiskSignalsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRiskSignalsSecurityOption1$outboundSchema: z.ZodMiniType<
  GetRiskSignalsSecurityOption1$Outbound,
  GetRiskSignalsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getRiskSignalsSecurityOption1ToJSON(
  getRiskSignalsSecurityOption1: GetRiskSignalsSecurityOption1,
): string {
  return JSON.stringify(
    GetRiskSignalsSecurityOption1$outboundSchema.parse(
      getRiskSignalsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRiskSignalsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRiskSignalsSecurityOption2$outboundSchema: z.ZodMiniType<
  GetRiskSignalsSecurityOption2$Outbound,
  GetRiskSignalsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskSignalsSecurityOption2ToJSON(
  getRiskSignalsSecurityOption2: GetRiskSignalsSecurityOption2,
): string {
  return JSON.stringify(
    GetRiskSignalsSecurityOption2$outboundSchema.parse(
      getRiskSignalsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRiskSignalsSecurity$Outbound = {
  Option1?: GetRiskSignalsSecurityOption1$Outbound | undefined;
  Option2?: GetRiskSignalsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRiskSignalsSecurity$outboundSchema: z.ZodMiniType<
  GetRiskSignalsSecurity$Outbound,
  GetRiskSignalsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRiskSignalsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRiskSignalsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRiskSignalsSecurityToJSON(
  getRiskSignalsSecurity: GetRiskSignalsSecurity,
): string {
  return JSON.stringify(
    GetRiskSignalsSecurity$outboundSchema.parse(getRiskSignalsSecurity),
  );
}

/** @internal */
export type GetRiskSignalsRequest$Outbound = {
  from?: string | undefined;
  to?: string | undefined;
  mcp_server_id?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRiskSignalsRequest$outboundSchema: z.ZodMiniType<
  GetRiskSignalsRequest$Outbound,
  GetRiskSignalsRequest
> = z.pipe(
  z.object({
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    mcpServerId: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRiskSignalsRequestToJSON(
  getRiskSignalsRequest: GetRiskSignalsRequest,
): string {
  return JSON.stringify(
    GetRiskSignalsRequest$outboundSchema.parse(getRiskSignalsRequest),
  );
}
